import { take, call, put } from 'redux-saga/effects'
import * as types from '../../../../lib/actionTypes.es6'
import {
  getUssdFlows,
  getUssdSessions,
  getUssdSessionMessages,
  simulateStart,
  simulateResume
} from '../../../../lib/ussdSessionsRequests.es6'
import * as actions from './actions'
import { unAuthorizedNotification } from '../../../../lib/access.es6'
import { GAloggerException } from '../../../../lib/monitoring.es6'

export function* getUssdSessionsWatcher() {
  while (true) {
    const { payload: msisdn } = yield take(types.GET_USSD_SESSIONS_REQUEST)
    try {
      const response = yield call(getUssdSessions, msisdn)
      yield put(actions.getUssdSessionsSuccess(response.data))
    } catch (e) {
      if (e.response) unAuthorizedNotification(e)
      GAloggerException(e)
      yield put(actions.getUssdSessionsFail(e.response ? e.response.data : {}))
    }
  }
}

export function* getUssdMessagesWatcher() {
  while (true) {
    const { payload: msisdn } = yield take(types.GET_USSD_MESSAGES_REQUEST)
    try {
      const response = yield call(getUssdSessionMessages, msisdn)
      yield put(actions.getUssdMessagesSuccess(response.data))
    } catch (e) {
      if (e.response) unAuthorizedNotification(e)
      GAloggerException(e)
      yield put(actions.getUssdMessagesFail(e.response ? e.response.data : {}))
    }
  }
}

export function* getUssdFlowsWatcher() {
  while (true) {
    yield take(types.GET_USSD_FLOWS_REQUEST)
    try {
      const response = yield call(getUssdFlows)
      yield put(actions.getUssdFlowsSuccess(response.data))
    } catch (e) {
      if (e.response) unAuthorizedNotification(e)
      GAloggerException(e)
      yield put(actions.getUssdFlowsFail(e.response ? e.response.data : {}))
    }
  }
}

export function* simulateStartWatcher() {
  while (true) {
    const {
      payload: { flow, msisdn }
    } = yield take(types.SIMULATE_START_REQUEST)
    try {
      const response = yield call(simulateStart, flow, msisdn)
      yield put(actions.simulateStartSuccess(response.data))
    } catch (e) {
      if (e.response) unAuthorizedNotification(e)
      GAloggerException(e)
      yield put(actions.simulateStartFail(e.response ? e.response.data : {}))
    }
  }
}

export function* simulateResumeWatcher() {
  while (true) {
    const {
      payload: { msisdn, session, input }
    } = yield take(types.SIMULATE_RESUME_REQUEST)
    try {
      const response = yield call(simulateResume, msisdn, session, input)
      yield put(actions.simulateResumeSuccess(response.data))
    } catch (e) {
      if (e.response) unAuthorizedNotification(e)
      GAloggerException(e)
      yield put(actions.simulateResumeFail(e.response ? e.response.data : {}))
    }
  }
}
